export const driverCdlVerificationStatus = [
  'unverified',
  'verified',
  'declined',
  'expired',
] as const;

export type DriverCdlVerificationStatus =
  (typeof driverCdlVerificationStatus)[number];
